export const APP_NAME = 'inspire_project_perseus';
